import PropTypes from 'prop-types';
import { APPEARANCES, SIZES } from '../base-select/constants';

export const OPTION_TYPE = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  iconComponent: PropTypes.node.isRequired,
};

export const GROUP_OPTION_TYPE = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape(OPTION_TYPE)).isRequired,
};

export const LANGUAGE_SELECT_PROPS = {
  id: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape(GROUP_OPTION_TYPE), PropTypes.shape(OPTION_TYPE)])
  ).isRequired,
  defaultValue: PropTypes.shape(OPTION_TYPE),
  defaultInputValue: PropTypes.string,
  placeholder: PropTypes.string,
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
  size: PropTypes.oneOf(Object.values(SIZES)),
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  preventOverflow: PropTypes.bool,
  openMenuOnFocus: PropTypes.bool,
  filterOptionsFunction: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onCreateOption: PropTypes.func,
};
